import * as brokerActions from "@rentiohq/shared-frontend/dist/redux/broker/broker.actions";
import * as brokerSelectors from "@rentiohq/shared-frontend/dist/redux/broker/broker.selectors";
import { IRootStore } from "redux/reducers";
import { EField } from "./schema.rentmatchScoreBroker.types";

export const isPerformingSubmitActionSelector =
  (brokerId: number) => (state: IRootStore) =>
    brokerSelectors.update.isUpdating(state, brokerId);

export const performingSubmitActionErrorSelector =
  (brokerId: number) => (state: IRootStore) =>
    brokerSelectors.update.updateError(state, brokerId);

export const performingSubmitActionResultSelector =
  (brokerId: number) => (state: IRootStore) =>
    brokerSelectors.detail.detail(state, brokerId);

/**
 * Back to the standard, which means storing nothing at all.
 *
 * The standard is not a table. A property with no office table is scored by a
 * sliding scale: three times the rent at 500 euro, easing down to twice the
 * rent at 3000 and above. The three bands this screen starts you off with are a
 * rough approximation of that curve, and writing them would leave the office
 * scoring differently from an office that never touched the screen, by as much
 * as two tenths of the rent in the middle of the range.
 *
 * So reset clears the column. Written rather than only shown, because an office
 * that resets is saying it wants the standard from now on.
 */
export const resetActionCreator = (brokerId: number) =>
  brokerActions.update.actions.start({
    id: brokerId,
    data: { rentmatchIncomeRanges: null },
  });

export const submitActionCreator = (brokerId: number) => (formData: any) =>
  brokerActions.update.actions.start({
    id: brokerId,
    data: {
      // Sent as the list it is, not as a string of one. The legacy broker
      // model declares this column as a list of objects stored in TEXT, so the
      // list is what it accepts and what a read hands back.
      //
      // Written whole, as points on a curve (DEV-3265): every row carries a
      // real rent and a multiple, and the reader runs straight between two
      // rows and flat beyond the outermost ones. There is no open-ended row.
      rentmatchIncomeRanges: formData[EField.IncomeRanges],
    },
  });
